import { render, staticRenderFns } from "./StudentSkill.vue?vue&type=template&id=f8bdfe28"
import script from "./StudentSkill.vue?vue&type=script&lang=js"
export * from "./StudentSkill.vue?vue&type=script&lang=js"
import style0 from "./StudentSkill.vue?vue&type=style&index=0&id=f8bdfe28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports